import React, {useEffect, useState} from "react";

import {StudyHeader} from "../components/study-note/study-note-header";
import {CreateStudyNote} from "../components/study-note/create-study-note";
import CenterDiv from "../components/utils/center-div";
import {useAuth} from "oidc-react";
import {useDispatch, useSelector} from "react-redux";
import {fetchStudyNotesAsync} from "../features/study-note/studyNoteSlice";
import {ListStudyNotes} from "../components/study-note/list-study-notes";
import PageWrapper from "../components/utils/PageWrapper";
import BackDrop from "../components/utils/back-drop";
import * as STATUS from "../httpClient";
import Button from "@mui/material/Button";
import {Add, LibraryBooks} from "@mui/icons-material";


const StudyPage = () => {
    const [createNewNote, setCreateNewNote] = useState(false);
    const auth = useAuth();
    const dispatch = useDispatch();

    const { status, studyNotes } = useSelector((state) => state.studyNotes);

    useEffect(() => {
        if (auth && auth.userData && studyNotes.length <= 0) {
            dispatch(fetchStudyNotesAsync(auth.userData.access_token))
        }
    }, [auth.userData])
    return (
        <div>
            <StudyHeader/>
            <CenterDiv>
                {
                    !createNewNote ?
                        <Button size={"large"} variant={"text"} onClick={() => setCreateNewNote(true)}>
                            create note <Add color={"success"}/>
                        </Button>
                        :
                        <Button size={"large"} variant={"text"} onClick={() => setCreateNewNote(false)}>
                            my notes <LibraryBooks color={"primary"}/>
                        </Button>
                }

            </CenterDiv>

            {
                createNewNote ?
                    <CreateStudyNote close={() => setCreateNewNote(false)}/>
                    :
                    <>
                        <PageWrapper mt={'1rem'}>
                            <ListStudyNotes notes={studyNotes} />
                        </PageWrapper>
                    </>
            }

            <BackDrop open={status === STATUS.LOADING} message={"one moment please"}/>
        </div>
    )
}
export default StudyPage;
